export default __webpack_public_path__ + "static/media/260.c2bc822e.png";